import type { NewsItem } from "@/types/media";

export const newsList: NewsItem[] = [
  {
    id: "n001",
    title: "《长安夜行》迎来大结局：一封三十年前的密信，揭开长安旧案全貌",
    date: "2026-10-12",
    category: "剧集动态",
    author: "编辑：南岸",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20news%20image%20of%20an%20ancient%20Chinese%20city%20street%20at%20night%20with%20glowing%20red%20lanterns%20and%20distant%20palace%20silhouette%2C%20deep%20indigo%20and%20warm%20orange%20palette%2C%20cinematic%20atmospheric%20mood%2C%20wide%20horizontal%20composition&width=800&height=450&seq=17c-news-001&orientation=landscape",
    excerpt: "开播以来口碑持续走高的年度古装悬疑剧迎来收官，剧中埋藏多集的核心谜题终于给出答案。",
    content: [
      "年度古装悬疑剧《长安夜行》于本周更新最后一集，随着那封尘封三十年的密信被公开，贯穿全剧的旧案终于迎来完整解答。",
      "该剧自开播以来，凭借扎实的剧本结构和考究的东方美学收获大量好评。主创团队表示，结局并非终点，而是希望观众在看完后，重新理解每一个角色最初的选择。",
      "在收官直播中，几位主演也分享了拍摄期间的点滴，并透露了不少幕后花絮。对于是否会推出续作，制片方表示正在慎重考虑，会以不辜负观众期待为前提推进。",
    ],
    relatedMediaId: "m002",
  },
  {
    id: "n002",
    title: "《星际回响》口碑逆袭：被低估的国产科幻，靠什么打动观众？",
    date: "2026-10-11",
    category: "电影评论",
    author: "编辑：昼行",
    cover: "https://readdy.ai/api/search-image?query=Editorial%20sci-fi%20article%20image%20of%20a%20lone%20spacecraft%20drifting%20near%20a%20ringed%20planet%20with%20soft%20nebula%20glow%2C%20deep%20navy%20and%20amber%20palette%2C%20cinematic%20wide%20composition%2C%20high%20detail&width=800&height=450&seq=17c-news-002&orientation=landscape",
    excerpt: "上映初期排片不佳，却在上映两周后凭口碑一路走高，这部电影做对了什么？",
    content: [
      "《星际回响》上映首周并不被看好，但随着观众口口相传，影片的评分与排片稳步回升，成为近期最受欢迎的国产科幻片之一。",
      "影评人普遍认为，影片最动人的地方在于它没有把重心放在炫目的特效上，而是用极简的场景与克制的对白，讨论人类在浩瀚宇宙中的孤独与连接。",
      "也有观众指出，影片的节奏偏慢，需要静下心来观看。但正是这种慢，让最后的结局拥有了足够的情感重量。",
    ],
    relatedMediaId: "m001",
  },
  {
    id: "n003",
    title: "国漫新标杆《深海来信》定档，预告片上线即热搜",
    date: "2026-10-10",
    category: "行业资讯",
    author: "编辑：叶澄",
    cover: "https://readdy.ai/api/search-image?query=Animated%20ocean%20scene%20with%20glowing%20jellyfish%20and%20sunlight%20rays%20through%20deep%20blue%20water%2C%20teal%20and%20warm%20gold%20accents%2C%20dreamy%20wide%20horizontal%20editorial%20composition&width=800&height=450&seq=17c-news-003&orientation=landscape",
    excerpt: "备受期待的国产动画电影发布正式预告，唯美的海底世界瞬间点燃观众讨论热情。",
    content: [
      "被誉为年度最值得期待的国产动画电影《深海来信》正式定档，同步上线的预告片在发布当晚便登上多个平台热搜。",
      "预告中展现的海底古城、发光水母群以及细腻的人物表演，让不少观众直呼「每一帧都是壁纸」。制作团队表示，影片历时五年打磨，希望带给观众一场关于勇气与约定的旅程。",
      "业内人士分析，随着国产动画工业水准不断提升，观众对本土动画的期待值也在持续走高。",
    ],
    relatedMediaId: "m009",
  },
  {
    id: "n004",
    title: "从《追光者》聊起：为什么平凡的励志故事总能打动人",
    date: "2026-10-09",
    category: "电影评论",
    author: "编辑：林澈",
    cover: "https://readdy.ai/api/search-image?query=Warm%20golden%20sunrise%20over%20the%20sea%20with%20a%20small%20lone%20figure%20and%20camera%20silhouette%2C%20amber%20and%20deep%20navy%20palette%2C%20hopeful%20cinematic%20wide%20editorial%20composition&width=800&height=450&seq=17c-news-004&orientation=landscape",
    excerpt: "没有超级英雄，也没有惊天反转，《追光者》用最朴素的坚持，讲出了最有力量的故事。",
    content: [
      "《追光者》讲述了一名年轻摄影师的成长历程，影片没有刻意制造戏剧冲突，而是把镜头对准日常生活里那些微小却真实的选择。",
      "不少观众表示，看完后最难忘的不是某个高光段落，而是主角一次次举起相机、又一次次放下时的沉默。",
      "导演在采访中提到，希望这部电影能让人相信：所谓追光，其实是在平凡的生活里，始终愿意再往前走一步。",
    ],
    relatedMediaId: "m021",
  },
  {
    id: "n005",
    title: "悬疑剧新趋势盘点：群像叙事为何越来越受欢迎",
    date: "2026-10-08",
    category: "行业资讯",
    author: "编辑：顾言",
    cover: "https://readdy.ai/api/search-image?query=Misty%20pine%20forest%20at%20dusk%20with%20cold%20fog%20and%20a%20lone%20distant%20headlight%2C%20deep%20green%20slate%20and%20pale%20silver%20palette%2C%20eerie%20wide%20cinematic%20editorial%20composition&width=800&height=450&seq=17c-news-005&orientation=landscape",
    excerpt: "近两年多部爆款悬疑剧都不约而同采用群像结构，这背后是怎样的观看心理变化？",
    content: [
      "从《沉默的证人》到《边境迷航》，越来越多悬疑作品选择用群像方式展开叙事，让每个角色都成为谜题的一部分。",
      "分析认为，群像叙事能够带来更强的代入感和讨论空间，观众不再只是被动的旁观者，而是主动拼凑线索的参与者。",
      "当然，群像也意味着更高的叙事难度。如何在有限篇幅内让每条线索都服务主线，仍是创作者需要面对的挑战。",
    ],
    relatedMediaId: "m019",
  },
  {
    id: "n006",
    title: "治愈系剧集回暖：《一屋两人三餐》凭什么成为下饭首选",
    date: "2026-10-07",
    category: "剧集动态",
    author: "编辑：金秀",
    cover: "https://readdy.ai/api/search-image?query=Sunlit%20cozy%20kitchen%20with%20wooden%20table%2C%20warm%20dishes%20and%20hanging%20plants%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20gentle%20morning%20light%2C%20wide%20horizontal%20editorial%20composition&width=800&height=450&seq=17c-news-006&orientation=landscape",
    excerpt: "没有狗血冲突，只有一餐一饭的温柔，《一屋两人三餐》悄悄拿下了高分。",
    content: [
      "在快节奏的生活里，一部讲述日常与陪伴的治愈系剧集意外走红，《一屋两人三餐》成为许多人睡前的固定陪伴。",
      "剧集用极生活化的台词和克制的情感表达，把「好好吃饭、好好生活」的主题讲得格外动人。",
      "有观众评论说，看完之后最大的收获，是重新愿意为自己认真做一顿饭。",
    ],
    relatedMediaId: "m012",
  },
  {
    id: "n007",
    title: "《时空旅人》深度解读：如果时间可以倒流，你会改变什么？",
    date: "2026-10-06",
    category: "电影评论",
    author: "编辑：Clara M.",
    cover: "https://readdy.ai/api/search-image?query=Abstract%20time%20portal%20with%20glowing%20light%20trails%20and%20two%20distant%20figures%2C%20teal%20and%20copper%20palette%2C%20ethereal%20dreamlike%20wide%20cinematic%20editorial%20composition&width=800&height=450&seq=17c-news-007&orientation=landscape",
    excerpt: "这部浪漫科幻片用一场逆向穿越，把「遗憾」这个永恒命题拍得格外温柔。",
    content: [
      "《时空旅人》表面上是一个关于时间穿越的科幻故事，内核却是一个关于接受与告别的爱情寓言。",
      "影片巧妙地让主角一次次试图改变过去，又一次次发现真正的答案并非改变，而是学会珍惜当下。",
      "结尾那个长镜头被不少观众反复讨论，有人说那是全片最温柔的留白。",
    ],
    relatedMediaId: "m007",
  },
  {
    id: "n008",
    title: "综艺季观察：竞技类与下饭类，两种快乐如何共存",
    date: "2026-10-05",
    category: "行业资讯",
    author: "编辑：何乐",
    cover: "https://readdy.ai/api/search-image?query=Bright%20variety%20show%20stage%20with%20colorful%20spotlights%20and%20confetti%2C%20abstract%20geometric%20shapes%2C%20vivid%20coral%20and%20navy%20palette%2C%20playful%20wide%20horizontal%20editorial%20composition&width=800&height=450&seq=17c-news-008&orientation=landscape",
    excerpt: "一边是肾上腺素飙升的竞技综艺，一边是轻松解压的下饭综艺，观众的选择越来越多元。",
    content: [
      "本季综艺市场呈现出明显的两极分化：竞技类节目追求高密度看点，生活类节目则主打陪伴与解压。",
      "《极速前进》用横跨多城的任务设计带来紧张感，而《厨房交响曲》则以烟火气十足的画面赢得观众好感。",
      "业内观点认为，两种路线并不冲突，观众会根据自己的心情选择不同的「快乐来源」。",
    ],
    relatedMediaId: "m016",
  },
];